import React, {useEffect, useState} from 'react';
import {Link, Redirect, Route, Switch, useHistory, useLocation,} from 'react-router-dom';
import {Select} from '../../components/Select';
import {ContactUsPage} from './ContactUsPage';
import {ExchangePage} from './ExchangePage';
import {FAQPage} from './FAQPage';
import {ShippingInfoPage} from './ShippingInfoPage';
import WashingAndHandlingPage from './WashingAndHandlingPage';
import {getCustomerCenterButtons} from "../../apis/contents";
import {CustomerCenterButtonDto} from "../../types/types";
import CustomPage from './CustomPage';

const tabs = [
    {id: 1, name: '문의하기', path: '/cc/contact-us'},
    // {id: 2, name: 'ORDER & PAYMENT', path: '/cc/order-and-payment'},
    // {id: 3, name: 'SHIPPING INFO', path: '/cc/shipping-info'},
    // {id: 4, name: 'EXCHANGE & PAYBACK', path: '/cc/exchange'},
    {id: 5, name: '세탁 및 취급 시 주의 사항', path: '/cc/cautions-for-washing-and-handling'},
    // {id: 5, name: 'AFTER SERVICE', path: '/cc/after-service'},
    // {id: 5, name: 'MEMBERSHIP & POINT', path: '/cc/membership'},
    // {id: 5, name: 'USE AGREEMENT', path: '/cc/user-agreement'},
    // {id: 5, name: 'PRIVACY POLICY', path: '/cc/privacy-policy'},
    {id: 5, name: '자주 하는 질문', path: '/cc/faq'},
];

export const CustomerCarePage = () => {
    const {pathname} = useLocation();
    const {push} = useHistory();
    const [buttons, setButtons] = useState<CustomerCenterButtonDto[]>([])

    useEffect(() => {
        getCustomerCenterButtons().then(r => {
            let data = r.data.payload.content;
            data.sort((a, b) => b.sort - a.sort);
            return setButtons(data);
        })
    }, [])

    useEffect(() => {
        window.scrollTo(0,0)
    }, [pathname])

    return (
        <>
            <div className="w-full flex flex-col md:mt-20 mt-8 -mx-4 md:-mx-0">

                {/* desktop buttons */}
                <div className="flex-wrap hidden md:flex max-w-screen-md justify-center gap-2 mx-auto">
                    {tabs.map((tab, index) => (
                        <Link key={index}
                              to={`${tab.path}`}
                              className={`w-40 text-center text-13 py-2 ${
                                  pathname.includes(`${tab.path}`)
                                      ? 'bg-gray-900 text-white'
                                      : 'border border-gray-900 bg-white text-gray-900'
                              }`}
                        >
                            {tab.name}
                        </Link>
                    ))}
                    {buttons.filter(item => item.active).map((button, index) => (
                        <Link key={index}
                              to={`/cc/custom/${button.id}`}
                              className={`w-40 text-center text-13 py-2 ${pathname === `/cc/custom/${button.id}`
                                  ? 'bg-gray-900 text-white'
                                  : 'border border-gray-900 bg-white text-gray-900'}`}
                        >
                            {button.button}
                        </Link>
                    ))}
                </div>

                {/* mobile view */}
                <Select
                    className="md:hidden pl-4 border-black border m-auto w-full ml-4"
                    value={pathname}
                    onChange={(e) => push(e.target.value)}
                >
                    {tabs.map((tab, index) => (
                        <option key={index} value={tab.path}>{tab.name}</option>
                    ))}
                    {buttons.filter(item => item.active).map((button, index) => (
                        <option value={`/cc/custom/${button.id}`} key={index}>{button.button}</option>
                    ))}
                </Select>

                <div className="mt-5 md:mt-24">
                    <Switch>
                        <Route component={FAQPage} path="/cc/faq"/>
                        <Route component={ExchangePage} path="/cc/exchange"/>
                        <Route component={ShippingInfoPage} path="/cc/shipping-info"/>
                        <Route component={ContactUsPage} path="/cc/contact-us"/>
                        <Route component={WashingAndHandlingPage} path="/cc/cautions-for-washing-and-handling"/>
                        <Route path={'/cc/custom/:id'} component={CustomPage}/>

                        <Route path="/cc">
                            <Redirect to="/cc/contact-us"/>
                        </Route>
                    </Switch>
                </div>
            </div>
        </>
    );
};
